module.exports = __webpack_public_path__ + "img/56.eba1d8c7.png";